/**
 * Selects the anchor with text 'All' if no anchor has 'selected' or 'disabled' classes.
 * @param {HTMLElement} container - The container element to search within.
 */
function selectAllIfNoneSelectedOrDisabled(container) {
	var anchors = container.querySelectorAll('a[data-type="category"]');
	var hasSelectedOrDisabled = Array.from(anchors).some(function(a) {
		var span = a.querySelector('.refinement-category');
		return (span && span.classList.contains('selected')) || a.classList.contains('disabled');
	});
	if (!hasSelectedOrDisabled) {
		var allAnchor = Array.from(anchors).find(function(a) {
			var span = a.querySelector('.refinement-category');
			return span && span.textContent.trim().toLowerCase() === 'all';
		});
		if (allAnchor) {
			allAnchor.classList.add('disabled');
			var allSpan = allAnchor.querySelector('.refinement-category');
			if (allSpan) {
				allSpan.classList.add('selected');
			}
		}
	}
}

selectAllIfNoneSelectedOrDisabled(document.querySelector('.category-refinement-embla__list'));